import { NgModule, inject } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Role } from 'src/app/models';
import { AuthGuard } from 'src/app/services/auth/auth-guard';
import { Buy2WinComponent } from './buy-2-win/buy-2-win.component';
import { CampaignDetailsComponent } from './buy-2-win/campaign-details/campaign-details.component';
import { CouponDetailComponent } from './coupons/coupon-detail/coupon-detail.component';
import { CouponsComponent } from './coupons/coupons.component';
import { EmailTemplatesComponent } from './email-templates/email-templates.component';
import { GlampointsActionCreditComponent } from './glampoints-actions/glampoints-action-credit/glampoints-action-credit.component';
import { GlampointsActionFormComponent } from './glampoints-actions/glampoints-action-form/glampoints-action-form.component';
import { GlampointsActionHistoryComponent } from './glampoints-actions/glampoints-action-history/glampoints-action-history.component';
import { GlampointsActionsComponent } from './glampoints-actions/glampoints-actions.component';
import { MovementsComponent } from './movements/movements.component';
import { MovementsHistoryComponent } from './movements/movements-history/movements-history.component';
import { ShopCouponDetailComponent } from './shop-coupons/shop-coupon-detail/shop-coupon-detail.component';
import { ShopCouponsComponent } from './shop-coupons/shop-coupons.component';

const canActivateGlampoints = () =>
  inject(AuthGuard).canActivate() &&
  inject(AuthGuard).canActivatePermissions([Role.Marketing, Role.Full_Administrator]);

const canActivateMovements = () =>
  inject(AuthGuard).canActivate() &&
  inject(AuthGuard).canActivatePermissions([
    Role.Full_Administrator,
    Role.Marketing,
    Role.Logistics
  ]);

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'coupons' },
  {
    path: 'chame-as-amigas',
    loadChildren: () =>
      import('./chame-as-amigas/chame-as-amigas.module').then(
        (m) => m.ChameAsAmigasModule
      )
  },
  {
    path: 'movements',
    component: MovementsComponent,
    canActivate: [canActivateMovements]
  },
  {
    path: 'movements/history',
    component: MovementsHistoryComponent,
    canActivate: [canActivateMovements]
  },
  { path: 'coupons', component: CouponsComponent },
  { path: 'coupons/:couponId', component: CouponDetailComponent },
  { path: 'shop-coupons', component: ShopCouponsComponent },
  { path: 'shop-coupons/new', component: ShopCouponDetailComponent },
  { path: 'shop-coupons/:couponId', component: ShopCouponDetailComponent },
  {
    path: 'buy-2-win',
    component: Buy2WinComponent
  },
  {
    path: 'buy-2-win/:campaignId',
    component: CampaignDetailsComponent
  },
  {
    path: 'email-templates',
    component: EmailTemplatesComponent
  },
  { path: 'email-templates/new', component: EmailTemplatesComponent },
  {
    path: 'glampoints-actions',
    component: GlampointsActionsComponent,
    canActivate: [canActivateGlampoints]
  },
  {
    path: 'glampoints-actions/new',
    component: GlampointsActionFormComponent,
    canActivate: [canActivateGlampoints]
  },
  {
    path: 'glampoints-actions/:actionId/credit',
    component: GlampointsActionCreditComponent,
    canActivate: [canActivateGlampoints]
  },
  {
    path: 'glampoints-actions/:actionId/history',
    component: GlampointsActionHistoryComponent,
    canActivate: [canActivateGlampoints]
  },
  {
    path: 'glampoints-actions/:actionId',
    component: GlampointsActionFormComponent,
    canActivate: [canActivateGlampoints]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MarketingRoutingModule {}
